module.exports = __webpack_public_path__ + "static/img/anli.b2324565.png";